const OVERRIDE_VISIBILITY = null; // null = use experiment, boolean = force show/hide

export class SupportWidgetExperiment {
  constructor(shadowRoot) {
    this.root = shadowRoot;
    this.proposition = null;
    this.variant = null;
    this.widgetVisible = true; // Default to visible

    // Check for debug override first
    if (OVERRIDE_VISIBILITY !== null) {
      console.log('[Experiment] Debug override active:', OVERRIDE_VISIBILITY ? 'SHOW' : 'HIDE');
      this.widgetVisible = OVERRIDE_VISIBILITY;
      this.updateWidgetVisibility();
    } else {
      // Setup listener - will re-render if Target event is received
      this.autoFetchExperiment();
    }
  }

  autoFetchExperiment() {
    // Trigger alloy to request Target decision (if available)
    if (typeof window.alloy !== 'function') return;

    alloy("sendEvent", {
      renderDecisions: false,
      personalization: {
        decisionScopes: ["__view__"],
      },
      xdm: {
        web: {
          webPageDetails: {
            URL: window.location.href
          }
        }
      },
    })
      .then(res => this.handleExperimentResponse(res))
      .catch(err => console.error('Error fetching experiment:', err))
  }

  handleExperimentResponse(res) {
    console.log({ res });
    // Extract propositions from the response
    const propositions = res?.propositions || [];
    
    if (propositions.length > 0) {
      const [proposition] = propositions;
      this.proposition = proposition;
      this.variant = this.extractVariant(this.proposition);
    }

    // Determine visibility based on variant
    this.widgetVisible = this.shouldShowWidget('true');
    // this.widgetVisible = this.shouldShowWidget('Widget hidden');
    const { variant, widgetVisible } = this;
    console.log('Experiment fetched', { variant, widgetVisible });
    
    // Apply visibility
    this.updateWidgetVisibility();
  }

  extractVariant(proposition) {
    // The correct experiment is not always the first one returned by the Target API
    // Find the experiment using the activity name
    const item = proposition.items.find(v => v.meta['activity.name'].startsWith('ExL: Support widget ticket creation form')) ?? null;
    return item?.meta['experience.name'] ?? null;
  }

  shouldShowWidget(variant) {
    switch (variant) {
      case 'Widget hidden':
        return false;
      // case 'Widget shown':
      default:
        return true;
    }
  }

  updateWidgetVisibility() {
    // Target only the Support Insights widget (not the Recommendation panel)
    const insightsContainer = this.root?.querySelector('.support-insights-section');

    if (this.widgetVisible) {
      insightsContainer?.classList.remove('experiment-hidden');
    } else {
      insightsContainer?.classList.add('experiment-hidden');
    }
  }

  isWidgetVisible() {
    return this.widgetVisible;
  }

  getVariant() {
    return this.variant;
  }

  getProposition() {
    return this.proposition;
  }


  trackConversion() {
    if (!this.proposition) return;
    
    // Send event to Adobe Target to track the experiment
    alloy("sendEvent", {
      "xdm": {
        "eventType": "decisioning.propositionDisplay",
        "_experience": {
          "decisioning": {
            "propositions": [{
              "id": this.proposition.id,
              "scope": this.proposition.scope,
              "scopeDetails": this.proposition.scopeDetails
            }],
            "propositionEventType": {
              "display": 1
            }
          }
        }
      }
    }).catch(err => {
      console.error('Error tracking experiment:', err)
    }).then(h => {
      console.log('Experiment tracked', h);
    })
  }
}

export const createSupportWidgetExperiment = (shadowRoot) => new SupportWidgetExperiment(shadowRoot);
export default SupportWidgetExperiment;
